import { ParamsMapping, RoutingConfig, CmsConfig, AuthGuard } from '@spartacus/core';
import { ListService, UnitListService, ItemService, UnitItemService } from '@spartacus/organization/administration/components';
import { AdminGuard } from '@spartacus/organization/administration/core';
import { UigUnitRoutePageMetaResolver } from '../services/uig-unit-route-page-meta.resolver';
import { ROUTE_PARAMS } from '../uig-organization.model';
import { UigUnitDetailsComponent } from './uig-unit-details/uig-unit-details.component';
import { UigUnitFormComponent } from './uig-unit-form/uig-unit-form.component';
import { UigUnitListComponent } from './uig-unit-list/uig-unit-list.component';

const listPath = `organization/units/:${ROUTE_PARAMS.unitCode}`;
const paramsMapping: ParamsMapping = {
  unitCode: 'uid',
  addressId: 'id',
  userCode: 'customerId',
};

export const uigUnitsRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      orgUnits: {
        paths: ['organization/units'],
      },
      orgUnitDetails: {
        paths: [listPath],
        paramsMapping,
      },
      orgUnitEdit: {
        paths: [`${listPath}/edit`],
        paramsMapping,
      },
    },
  },
};


export const uigUnitsCmsConfig: CmsConfig = {
  cmsComponents: {
    ManageUnitsListComponent: {
      component: UigUnitListComponent,
      providers: [
        {
          provide: ListService,
          useExisting: UnitListService,
        },
        {
          provide: ItemService,
          useExisting: UnitItemService,
        },
      ],
      childRoutes: {
        parent: {
          data: {
            cxPageMeta: {
              breadcrumb: 'unitsBreadcrumbs.list',
              resolver: UigUnitRoutePageMetaResolver,
            },
          },
        },
        children: [
          {
            path: `:${ROUTE_PARAMS.unitCode}`,
            component: UigUnitDetailsComponent,
            data: {
              cxPageMeta: { breadcrumb: 'orgUnit.breadcrumbs.details' },
            },
            children: [
              {
                path: 'edit',
                component: UigUnitFormComponent,
              },
            ],
          },
        ],
      },
      guards: [AuthGuard, AdminGuard],
    },
  },
};





